import { Menu, Transition } from "@headlessui/react";
import cx from "classnames";
import { ChevronIcon } from "../../atoms/Icons";
import Text from "../../atoms/Text";
import Divider from "../../atoms/Divider";
import NavLink from "./NavLink";
import * as s from "./styles";
import { transitionProps } from "./utils";
import type { NavbarProps, NavbarLink } from "./index";

type NavbarDesktopProps = Pick<
  NavbarProps,
  "isOrganisationAdmin" | "labels"
> & {
  hasTeamSessionsOnly?: boolean;
  adminLinks: NavbarLink[];
  primaryLinks: NavbarLink[];
  secondaryLinks: NavbarLink[];
  organisationAdminLinks: NavbarLink[];
  variant: "light" | "dark";
};

export default function NavbarDesktop({
  adminLinks,
  isOrganisationAdmin,
  hasTeamSessionsOnly = false,
  labels,
  primaryLinks,
  secondaryLinks,
  organisationAdminLinks,
  variant,
}: NavbarDesktopProps) {
  return (
    <div className="flex flex-col gap-1 h-full">
      {primaryLinks.map((link) => (
        <NavLink
          key={`${link.href}-${link.label}`}
          {...link}
          variant={variant}
        />
      ))}

      {secondaryLinks.length > 0 && (
        <>
          {!hasTeamSessionsOnly && <Divider variant="dark" />}
          {secondaryLinks.map((link) => (
            <NavLink
              key={`${link.href}-${link.label}`}
              {...link}
              variant={variant}
            />
          ))}
        </>
      )}

      {isOrganisationAdmin && organisationAdminLinks.length > 0 && (
        <>
          <Divider variant="dark" />
          <div className="ml-4">
            <Text
              variant="label"
              color={variant === "dark" ? "white" : "primary-light"}
            >
              {labels.company}
            </Text>
          </div>

          {organisationAdminLinks.map((link) => (
            <NavLink
              key={`${link.href}-${link.label}`}
              {...link}
              variant={variant}
            />
          ))}
        </>
      )}

      {adminLinks.length > 0 && (
        <Menu>
          {({ open }) => (
            <>
              <Menu.Button
                className={cx(s.itemDark, "bg-purple-900 justify-between mt-3")}
              >
                <Text weight="bold" color="light">
                  {labels.admin}
                </Text>
                <ChevronIcon direction={open ? "up" : "down"} color="white" />
              </Menu.Button>
              <Transition {...transitionProps}>
                <Menu.Items>
                  {adminLinks.map((link) => (
                    <Menu.Item key={`${link.href}-${link.label}`}>
                      <NavLink {...link} variant={variant} />
                    </Menu.Item>
                  ))}
                </Menu.Items>
              </Transition>
            </>
          )}
        </Menu>
      )}
    </div>
  );
}
